import { IKnmReasonTypeExtended } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonTypeExtended';
import { IKnmReasonTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmReasonTypeSelectOption';

export const getKnmReasonType = (knmReasonType: IKnmReasonTypeExtended): IKnmReasonTypeSelectOption => ({
  ...knmReasonType,
  label: knmReasonType.name,
  value: knmReasonType.id.toString(),
});
